import React, { FunctionComponent } from "react";
import { Dropdown, Form } from "react-bootstrap";

import Limit from "../../models/limit/Limit";
import Registration from "../../models/registration/Registration";

interface Props {
  limits: Limit[];
  registrations: Registration[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

const toggleLabel = (selected: string[]): string => {
  if (selected.length === 0) return "Alle Angebote";
  if (selected.length === 1) return selected[0];
  return `${selected.length} Angebote`;
};

/** Mehrfachauswahl der Angebote; gezeigt werden Anmeldungen mit mindestens einem gewählten Angebot. */
export const OfferFilter: FunctionComponent<Props> = ({ limits, registrations, selected, onChange }) => {
  const toggle = (property: string): void =>
    onChange(selected.includes(property) ? selected.filter((item) => item !== property) : [...selected, property]);

  return (
    <Dropdown autoClose="outside" align="end">
      <Dropdown.Toggle
        as="button"
        type="button"
        className={`form-select header-select offer-filter__toggle${selected.length > 0 ? " is-active" : ""}`}
        aria-label="Nach Angeboten filtern"
        title={selected.join(", ") || undefined}>
        <span>{toggleLabel(selected)}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu className="offer-filter__menu">
        {limits.map((limit) => {
          const count = registrations.filter((registration) => registration.formData[limit.property]).length;
          return (
            <Form.Check
              key={limit.property}
              id={`offer-filter-${limit.property}`}
              className="offer-filter__item"
              type="checkbox"
              label={`${limit.property} (${count})`}
              checked={selected.includes(limit.property)}
              onChange={() => toggle(limit.property)}
            />
          );
        })}
        {selected.length > 0 && (
          <>
            <Dropdown.Divider />
            <button type="button" className="btn btn-link btn-sm offer-filter__reset" onClick={() => onChange([])}>
              Auswahl zurücksetzen
            </button>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};
